const enrichSchool = (school, {adminSchoolIds, teacherSchoolIds}) => {
  const district = school.districts?.[0];
  return {
    id: school.id,
    pk: school.pk,
    unique_id: school.unique_id,
    name: school.name,
    state: school.address?.state,
    city: school.address?.city,
    country: school.address?.country,
    zip_code: school.address?.zip_code,
    school_type: school.school_type,
    nces_id: school.nces_school_id,
    district: district
      ? {id: district.id, pk: district.pk, unique_id: district.unique_id, name: district.name}
      : undefined,
    is_admin: adminSchoolIds.has(school.id),
    is_teacher: teacherSchoolIds.has(school.id),
  };
};

const sortPreferredFirst = (schools, preferredSchoolUuid) => {
  if (!preferredSchoolUuid) return schools;
  const preferredIndex = schools.findIndex((s) => s.unique_id === preferredSchoolUuid);
  if (preferredIndex <= 0) return schools;
  const sorted = [...schools];
  const [preferred] = sorted.splice(preferredIndex, 1);
  sorted.unshift(preferred);
  return sorted;
};

const mapUserToPendoProperties = (user, userAttributes, {isImpersonated}) => {
  if (!user?.pk && !user?.id) {
    return null;
  }

  const adminSchoolIds = new Set(
    [user.school_admin?.school?.id, user.principal?.school?.id].filter(
      (id) => typeof id === 'number'
    )
  );
  const teacherSchoolIds = new Set(
    [user.teacher?.school?.id].filter((id) => typeof id === 'number')
  );

  const preferredSchoolUuid = userAttributes?.preferred_school_id;
  const enrichedSchools = (user.schools ?? []).map((school) =>
    enrichSchool(school, {adminSchoolIds, teacherSchoolIds})
  );
  const schools = sortPreferredFirst(enrichedSchools, preferredSchoolUuid);

  return {
    id: user.pk ?? user.id,
    unique_id: user.unique_id,
    is_authenticated: user.is_authenticated ?? false,
    is_impersonated: isImpersonated,
    product: 'monolith',
    student: user.student,
    teacher: user.teacher,
    district_admin: user.district_admin?.district?.id
      ? {district: {id: user.district_admin.district.id}}
      : undefined,
    school_admin: user.school_admin?.role ? {role: user.school_admin.role} : undefined,
    licenses: user.licenses,
    schools,
    grade_levels: user.classroom_grade_levels,
    classrooms: undefined,
    date_joined: user.date_joined,
    email: user.email,
    first_name: user.first_name,
    last_name: user.last_name,
    state: userAttributes?.state ?? user.state,
    auth_type: user.auth_type,
    roles: user.roles,
    is_demo: userAttributes?.is_demo ?? user.is_demo,
    is_staff: user.is_staff,
    features: user.features,
  };
};

export default mapUserToPendoProperties;
